<template>
  <section class="jsk-block">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6 col-md-6">
          <p class="h3">{{ $t("aboutUs.title") }}</p>
          <p class="mt-3">{{ $t("aboutUs.descr[0]") }}</p>
          <p class="mb-5">{{ $t("aboutUs.descr[1]") }}</p>
          <a href="https://www.jsleague.ro/about" target="_blank" class="bold-underlined">{{ $t("aboutUs.moreAboutUsBtn") }}</a>
        </div>
        <div class="col-12 col-lg-6 col-md-6 text-right d-lg-block d-none">
          <img src="./../assets/images/team/about.jpg" class="w-75 img-fluid">     
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 col-lg-4 col-md-4 d-lg-block d-none">
          <img src="./../assets/images/team/mission.jpg" class="img-fluid">     
        </div>
        <div class="col-12 col-lg-6 col-md-6 offset-lg-1">
          <p class="h3">{{ $t("aboutUs.mission") }}</p>
          <p class="mt-3">{{ $t("aboutUs.missionDescr[0]") }}</p>
          <p>{{ $t("aboutUs.missionDescr[1]") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "aboutUs"
};
</script>